import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "q4-2023-goals"
    }}>{`Q4 2023 Goals`}</h2>
    <ol>
      <li parentName="ol">{`Continued maintenance of systems`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Int -> bigint on postgres EU`}</li>
      <li parentName="ul">{`EKS 1.28+`}</li>
    </ul>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Controlling costs`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Reduce cross AZ traffic`}</li>
      <li parentName="ul">{`Rust capture`}</li>
    </ul>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Platform improvements`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Better kafka ops `}</li>
      <li parentName="ul">{`Try confluent/redpanda/whatever instead of MSK`}</li>
      <li parentName="ul">{`Figure out how to hotswap clusters quickly if required`}</li>
      <li parentName="ul">{`Write a guide to take a full stack engineer to confidently make the first debugging steps themselves`}</li>
      <li parentName="ul">{`Provide a logging + tracing system that engineers want to use`}</li>
      <li parentName="ul">{`A deploy workflow that every engineer can use`}</li>
      <li parentName="ul">{`Easy dev deploys`}</li>
      <li parentName="ul">{`Easy rollbacks using Github Actions`}</li>
    </ul>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Clickhouse changes	`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Migrate to Clickhouse cloud`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      